"use client";
import { ageGateCookie, ageGateNo } from '../../app/actions'

export default function AgeGateContent() {
  return(
  <>
    <title>StationHouse</title>
    <div id="age-parent" className="age-verif-parent">
      <div className="age-popup">
        <div className="popup-brand-img"><img src="images/popup-brand-img.svg" loading="lazy" alt="" /></div>
        <div id="error-box" className="error-msg">
          <div className="error-text">You are not old enough to visit this site </div>
        </div>
        <h1 className="popup-head">Attention</h1>
        <h2 className="popup-head-2">You must be over 19 to ride the train. </h2>
        <div className="popup-verify-text">Are you over 19 years of age?</div>
        <div className="popup-terms-text">By clicking “YES”, you confirm that you are of legal age to purchase cannabis.
        </div>
        <div className="popup-button-div">
          <a id="over-age"
            onClick={() => ageGateCookie()}
            href="#" className="overage-butt w-button">yes</a>
          <a id="under-age"
            onClick={() => ageGateNo()}
            href="#" className="underage-butt w-button">No, Re-Route</a>
        </div>
        <div className="popup-terms-text">To access Station House.ca you must be of legal cannabis consumption age in
          your province of residence in Canada and agree to our <a href="/terms-of-use" className="popup-link">terms
            of use</a> and <a href="/privacy-policy" className="popup-link">privacy policy</a>.</div>
      </div>
    </div>
  </>
  )
};